import { render, staticRenderFns } from "./FormSelectableListEditor.vue?vue&type=template&id=2b194f3f&scoped=true"
import script from "./FormSelectableListEditor.vue?vue&type=script&lang=js"
export * from "./FormSelectableListEditor.vue?vue&type=script&lang=js"
import style0 from "./FormSelectableListEditor.vue?vue&type=style&index=0&id=2b194f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b194f3f",
  null
  
)

export default component.exports